export const REGEXPS = {
  EMAIL_REGEXP: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  PHONE_REGEXP: /^\+?[0-9]{10,}$/
}
